var CurrentUser = require("lib/account/CurrentUser");
var Cookies = require("js-cookie");

export function switchToStudent(student) {
	var username = student.username;
	var password = student.password;

	if (!(username && password)) {
		throw "Student is missing username or password."
	}

	if (!student.demo_for_teacher) {
		throw "Can only switch to demo_for_teacher student accounts"
	}

	var domain = CurrentUser.getCookieDomain()
	_.each(COOKIE_MAP, (userKey, returnKey) => {
		var userValue = Cookies.get(userKey, { domain: domain });
		Cookies.set(returnKey, userValue, { expires: 10000, domain: domain });
	})

	window.wrNotifications.triggerDropDownNotification({
		title: "Switching to demo account", text: "Just a few moments....", icon: "random" }, 10000);

	CurrentUser.usernamePasswordAuthenticate(username, password, (success, errorText) => {
		if (success) {
			$wr.redirect('/');
			window.location.reload();
		} else {
			throw "Account switcher error: " + errorText;
		}
	});
}

export function returnToAccount() {
	if (!hasReturnAccount()) {
		return;
	}

	var domain = CurrentUser.getCookieDomain()

	_.each(COOKIE_MAP, (userKey, returnKey) => {
		var returnValue = Cookies.get(returnKey, { domain: domain });
		Cookies.set(userKey, returnValue, { expires: 10000, domain: domain });
		Cookies.remove(returnKey, { domain: domain });
	});

	$wr.redirect('/');
	window.location.reload()
}

export function hasReturnAccount() {
	var user = CurrentUser.get();

	if (user == undefined || !user.demo_for_teacher) {
		return false;
	}

	var domain = CurrentUser.getCookieDomain()

	var hasAccount = true;
	_.each(COOKIE_MAP, (userKey, returnKey) => {
		hasAccount = hasAccount && Cookies.get(returnKey, { domain: domain });
	});

	return hasAccount;
}


var RETURN_USER_ID_KEY = "wr_returnCurrentUserID";
var RETURN_USER_TYPE_KEY = "wr_returnCurrentUserType";
var RETURN_USER_TOKEN_KEY = "wr_returnCurrentUserToken";

var COOKIE_MAP = {
	[RETURN_USER_ID_KEY]: CurrentUser.USER_ID_KEY,
	[RETURN_USER_TYPE_KEY]: CurrentUser.USER_TYPE_KEY,
	[RETURN_USER_TOKEN_KEY]: CurrentUser.USER_TOKEN_KEY
}


// WEBPACK FOOTER //
// ./modules/lib/account/DemoAccountSwitcher.js